import { render, staticRenderFns } from "./applygdtdouyingSoul.vue?vue&type=template&id=48c92fe1&scoped=true&"
import script from "./applygdtdouyingSoul.vue?vue&type=script&lang=js&"
export * from "./applygdtdouyingSoul.vue?vue&type=script&lang=js&"
import style0 from "./applygdtdouyingSoul.vue?vue&type=style&index=0&id=48c92fe1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c92fe1",
  null
  
)

export default component.exports